import script from "./MenuBarButtonImage.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBarButtonImage.vue?vue&type=script&setup=true&lang=js"

import "./MenuBarButtonImage.vue?vue&type=style&index=0&id=2e39f954&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e39f954"]])

export default __exports__